import { render, staticRenderFns } from "./LinkQuestionsForm.vue?vue&type=template&id=5b3f37f5"
import script from "./LinkQuestionsForm.vue?vue&type=script&lang=js"
export * from "./LinkQuestionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports